import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { UserType } from "../modals/UserModal";

// Define the initial state using that type
const initialState: UserType = {
  id: -1,
  global_id: "",
  username: "",
  last_login_at: "",
  is_active: false,
  primary_client_id: 0,
  totp_secret: "",
  totp: false,
  email_otp: false,
  totp_uri: "",
  reason_for_blocking: "",
  exclude_from_device_auth: false,
  force_reset_password: false,
  created_by: "",
  profile: {
    first_name: "",
    middle_name: "",
    last_name: "",
    organization: "",
    meta: "",
    profile_image: "",
  },
  phone: [],
  email: [],
  scope: [],
  client: [],
  alias: [],
  isConnected: true,
  banner: null,
};

export const userSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    updateUser: (state, action: PayloadAction<UserType>) => {
      return { ...state, ...action.payload };
    },
    updateIsConnected: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
    updateUserBanner: (state, action: PayloadAction<any>) => {
      state.banner = action.payload;
    },
    resetUser: () => initialState,
  },
});

export const { updateUser, resetUser, updateIsConnected, updateUserBanner } =
  userSlice.actions;

export default userSlice.reducer;
